import {Component, Input, OnInit} from '@angular/core';
import {BrowseComponent} from "@shared/components/browse/abstract.browse.component";
import {Pagination} from "@core/bean/pagination";
import {CommonsService} from "@core/service/commons.service";
import {NzModalService} from "ng-zorro-antd";
import {HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {BrowseConfig} from "@core/bean/browse-config";
import {PersonService} from "../../../../routes/jy-org/person/service/person.service";


/**
 * 人员浏览按钮
 */
@Component({
  selector: 'person-browse',
  templateUrl: './person.browse.component.html'
})
export class PersonBrowseComponent implements BrowseComponent, OnInit {

  static componentName = 'PersonBrowseComponent';

  @Input() config:BrowseConfig;
  @Input() onOk:(data:any | [any]) => void;
  @Input() onCancel:() => void;

  visible = false;
  formLoading = false;
  pagination:Pagination = new Pagination();
  searchData:any = {};
  constructor(private commonsService:CommonsService,
              private modalService:NzModalService,
              private jyPersonService:PersonService) {

    this.pagination.getData = function (params:HttpParams):Observable<any> {
      return jyPersonService.query(params);
    }

  }


  ngOnInit() {
    if (!this.config.multiple) {
      this.pagination.multipleCheck = false;
    }
    this.searchData = this.config.searchData;
    this.searchData['user.activated']="true";
    this.getData();
    this.visible = true;
  }

  getData() {
    this.pagination.searchData = this.searchData;
    this.pagination.toFirstPage();
  }

  modalOk() {
    let result = this.pagination.selectedRows;
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  modalCancel() {
    this.visible = false;
    this.onCancel();
  }

  selectData(data){
    let result = [data];
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }
}
